import axios from 'axios';
import { api, headers } from '../../app/conf';

export const getCompanyService = (token, companyId) =>
    axios({
        method: 'get',
        url: `${api}/v1/companies/${companyId}`,
        headers: {
            ...headers,
            'X-Access-Token': token
        }
    })